import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVerifyAdminQuery } from '../../Api/admin';
import Button from '../../Style-guide/Button';
import AddCourtModal from './addCourtModal';
import CreateOrganizerModal from './createOrganizerModal';
import DeleteCourtModal from './deleteCourtModal';
import DeleteOrganizerModal from './deleteOrganizerModal';
import AdminActionsWrapper from './style/adminActionsWrapper';

const AdminActions = () => {
  const { data, isError, isSuccess, isFetching } = useVerifyAdminQuery();
  const navigate = useNavigate();
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    if (!isFetching) {
      if (isError || (isSuccess && !data?.authenticated)) {
        navigate('/admin');
      }
    }
  }, [data, isError, isSuccess, isFetching, navigate]);

  return (
    <AdminActionsWrapper>
      <div className='organizer-actions-container'>
        <Button onClick={() => setActiveModal('create-organizer')}>
          Create organizer
        </Button>
        <Button onClick={() => setActiveModal('delete-organizer')}>
          Delete organizer
        </Button>
        <Button onClick={() => setActiveModal('add-court')}>Add court</Button>
        <Button onClick={() => setActiveModal('delete-court')}>Delete court</Button>
      </div>
      <CreateOrganizerModal
        isModalOpen={activeModal === 'create-organizer'}
        setIsModalOpen={() => setActiveModal(null)}
      />
      <DeleteOrganizerModal
        isModalOpen={activeModal === 'delete-organizer'}
        setIsModalOpen={() => setActiveModal(null)}
      />
      <AddCourtModal
        isModalOpen={activeModal === 'add-court'}
        setIsModalOpen={() => setActiveModal(null)}
      />
      <DeleteCourtModal
        isModalOpen={activeModal === 'delete-court'}
        setIsModalOpen={() => setActiveModal(null)}
      />
    </AdminActionsWrapper>
  );
};

export default AdminActions;
